import { safeExternalUrl } from '../../utils/safeNavigation';
import { getCalendarConnections, startCalendarOAuth, disconnectCalendar, getExternalCalendarBusy, createCalendarFeed } from './backend';

export async function listCalendarConnections() { return getCalendarConnections(); }

export async function connectCalendar(provider) {
  const result = await startCalendarOAuth(provider, window.location.origin);
  if (!result?.authorizationUrl) throw new Error('Calendar authorization URL was not returned.');
  const authorizationUrl = safeExternalUrl(result.authorizationUrl, { allowBlob: false });
  if (!authorizationUrl) throw new Error('Calendar provider returned an unsafe authorization URL.');
  const popup = window.open(authorizationUrl, `telcofair-${provider}-calendar`, 'width=620,height=760,resizable=yes,scrollbars=yes,noopener,noreferrer');
  if (!popup) { window.location.assign(authorizationUrl); return { redirected: true }; }
  const callbackOrigin = window.location.origin;
  return new Promise((resolve, reject) => {
    let timer;
    const cleanup = () => { window.removeEventListener('message', onMessage); if (timer) clearInterval(timer); };
    const onMessage = (event) => {
      if (event.origin !== callbackOrigin) return;
      if (event.data?.type === 'telcofair-calendar-connected' && event.data?.provider === provider && event.data?.state === result.state) { cleanup(); resolve({ ok: true, provider }); }
    };
    window.addEventListener('message', onMessage);
    timer = setInterval(() => {
      if (popup.closed) { cleanup(); resolve({ ok: false, closed: true, provider }); }
    }, 700);
    setTimeout(() => { cleanup(); try { popup.close(); } catch (_) {} reject(new Error('Calendar connection timed out.')); }, 10 * 60 * 1000);
  });
}

export async function removeCalendar(provider) { return disconnectCalendar(provider); }
export async function getBusyTimes({ companyId, targetUserId, start, end }) { return getExternalCalendarBusy(companyId, { targetUserId, start, end }); }
export async function createIcsFeed() { return createCalendarFeed(); }

export default { listCalendarConnections, connectCalendar, removeCalendar, getBusyTimes, createIcsFeed };
